import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
    name: "loader",
    initialState: {
         activeRequests: 0,
    },
    reducers: {
        showLoader: (state) => {
           state.activeRequests += 1;
        },
        hideLoader: (state) => {
           state.activeRequests = Math.max(0, state.activeRequests - 1);
        },
    },
});

export const { showLoader, hideLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
